import React, { useState } from 'react';

export const EditorTextInput = ({ value }) => {
    const [textValue, setTextValue] = useState(value);

    const handleTitleOnChange = (evt) => {
        setTextValue(evt.target.value);
    };

    return (
        <>
            <label htmlFor='blog-title'>Title</label>
            <br />
            <input
                name='title'
                id='blog-title'
                type='text'
                className='title-input'
                value={textValue}
                onChange={handleTitleOnChange}
            />
        </>
    );
};
